import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const setProjectConfigurationService = async (
    params
) => {
    const { project } = params;
    const apiPath = `projects/${project}/set-project-configuration`;

    const request = {
        // url: `http://localhost:3001/${apiPath}`,
        url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
        host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
        path: apiPath,
        method: 'POST',
        region: Config.AWS_REGION,
        service: 'execute-api',
        headers: {
            'Content-Type': 'application/json',
        },
        data: params,
        body: JSON.stringify(params),
    };

    const signedRequest = await createSignedRequest(request);

    const response = await axios(signedRequest);

    return response.data;
};
